export default [
  { num: 1,  full: 'понедельник', short: 'пн', en: 'monday' },
  { num: 2,  full: 'вторник',     short: 'вт', en: 'tuesday' },
  { num: 3,  full: 'среда',       short: 'ср', en: 'wednesday' },
  { num: 4,  full: 'четверг',     short: 'чт', en: 'thursday' },
  { num: 5,  full: 'пятница',     short: 'пт', en: 'friday' },
  { num: 6,  full: 'суббота',     short: 'сб', en: 'saturday' },
  { num: 7,  full: 'воскресенье', short: 'вс', en: 'sunday' },
];